import { render, staticRenderFns } from "./Refer.vue?vue&type=template&id=0b8e0e4d&"
import script from "./Refer.vue?vue&type=script&lang=js&"
export * from "./Refer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports